import $ from 'jquery';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import Immutable from 'immutable';
import listService from 'ListService';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/navigation/tabbing.ejs';
import TextUtil from 'util/TextUtil.js';
import undoService from 'UndoService';
import pageListUtil from 'util/ThumbPageListUtil.js';

class NavTabbingView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckboxAttributes',
            'keydown input[name=tabIndex]' : 'validatePositiveNumeric'
        };

        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }


    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldVal  = this.model.get(propName);

        if (propVal.toString() !== oldVal.toString()) {
            this.model.set( propName, propVal, {silent: true} );

            if (propName === 'tabIndex') {
                listService.reorderTabIndexes(this.model.get('id')).then( (data) => {
                    if (data.indexModified) {
                        this.render(); // in case the Index value was changed by reorder logic
                    }
                });
                //Get the positions that the object should move
                const positions = propVal - oldVal;
                pageListUtil.reorderByTabIndex(this.model.get('id'), positions);

            }else{
                this.render();
            }

            // PF-3465 Undo/Redo for Tabbing.
            undoService.add({
                undo: () =>{
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,oldVal,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.set(propName, oldVal );
                    }
                    if (propName === 'tabIndex') {
                        listService.reorderTabIndexes(this.model.get('id')).then( (data) => {
                            if (data.indexModified) {
                                this.render();
                            }
                        });

                    }else{
                        this.render();
                    }
                },
                redo:() => {
                    if(util.isGroupContainer(this.model.get('factoryKey'))){
                        util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                    }
                    else {
                        this.model.set( propName, propVal );
                    }
                    if (propName === 'tabIndex') {
                        listService.reorderTabIndexes(this.model.get('id')).then( (data) => {
                            if (data.indexModified) {
                                this.render();
                            }
                        });

                    }else{
                        this.render();
                    }
                }
            },textConstants.UNDO_TABBING)
        }
        
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldVal  = this.model.get(propName);
        
        if (propName==='tabEnabled'){
          this.model.set( propName, propVal, {silent: true} );
        }else{
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
            }
            else {
                this.model.set(propName,propVal);
            }
        }
        

        console.log(`Nav Tabbing model.set(${propName}, ${this.model.get( propName )})`);

        undoService.add({
            undo: () =>{
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set( propName, oldVal );
                }
            },
            redo:() => {
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
                }
                else {
                    this.model.set( propName, propVal );
                }
            }
        },textConstants.UNDO_TABBING_CHECK)
    }

    render() {

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        if (this.model.get('factoryKey') === 'control_text' ||
            this.model.get('factoryKey') === 'control_small_text' ||
            this.model.get('factoryKey') === 'control_large_heading' ||
            this.model.get('factoryKey') === 'control_medium_heading' ||
            this.model.get('factoryKey') === 'control_small_heading' ||
            this.model.get('factoryKey') === 'control_picture' ||
            this.model.get('factoryKey') === 'control_link' ||
            this.model.get('factoryKey') === 'control_progress_bar' ||
            this.model.get('factoryKey') === 'control_bullet_text' ) {

            $('#propTabStop').addClass('hide');
        }


        if (this.config.hideTooltip) {
            $('#navTooltip').addClass('hide');
        }

        let tabEnabled = util.isTrue(this.model.get('tabEnabled'));
        $(`input[name='tabEnabled']`).prop('checked', tabEnabled );

        this.addMultilanguageIcon();

        this.delegateEvents();
        return this;
    }

}

export default NavTabbingView;
